<template>
  <div class="profile-card">
    <div
      class="profile-card__grid profile-owl-carousel__img show profile-card__image profile-card__image--inner-shadow"
      v-bind:style="{ 'background-image': 'url(' + url + ')'}"
    >
      <div class="profile-card__info">
        <div class="profile-card__card-data">
          <div class="data-wrapper">
            <h6 class="card-data__name">{{ profile.name }}, {{ profile.age }}<span v-if="profile.is_online" class="dot-online members__online"></span></h6>
            <p class="card-data__city" v-if="profile.address_form !== 'hidden'">
              {{ profile.address_city }}, {{ parseInt(profile.location.distance) }} km</p>
          </div>
        </div>
      </div>
      <div class="profile-card__new-user">
        <div v-if="profile.is_new" class="label-card">{{ trans.get('pages:members.profile_card.new') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileCard',
  props: {
    profile: Object,
    src: String,
    showProfileDetails: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    url: function () {
      return this.src || this.profile.avatar_url;
    }
  },
  mounted() {
  }
};
</script>


